import axios from  'axios'
import { showLoading, hideLoading } from './loading';
import { showSpin, hideSpin } from './loading2';
import {baseUrl} from './const'



var instance = axios.create({
    baseURL:baseUrl,
    timeout:20000
});

export const $setToken=(token)=>{
    instance.defaults.headers.common['Authorization']=token
}

//封装get方法
export const $get=async (URL,params)=>{
   // showLoading();
    let {data}= await instance.get(URL,{
        params
    })
    //hideLoading();
    return data;
}

//封装post
export const $Login=async (URL,params)=>{
  // showLoading();
   let {data}=await instance.post(URL,params)
  // hideLoading();
   return data;
}


//封装post
export const $post=async (URL,params)=>{
   // showLoading();
   console.log(params.hasOwnProperty('team_id'))
   
   if(!params.hasOwnProperty('team_id')){
    let userInfo=JSON.parse(localStorage.getItem("userInfo"));
    if(userInfo.team_id){
      params.team_id=userInfo.team_id;
      params.team_name=userInfo.team_name
    }else{
      params.team_id="";
      params.team_name="";
    }
      
   }
   
    let {data}=await instance.post(URL,params)
   // hideLoading();
    return data;
}





//封装put
export const $put=async (URL,params)=>{
  let userInfo=JSON.parse(localStorage.getItem("userInfo"));

   // showLoading();
    let {data}=await instance.put(URL,params)
   // hideLoading();
    return data;
}


//封装delete,delete方法和get方法一样，需要对params参数进行再包装一下
export const $delete=async (URL,params)=>{
  let userInfo=JSON.parse(localStorage.getItem("userInfo"));
  
  params.team_id=userInfo.team_id;
    params.team_name=userInfo.team_name
   // showLoading();
    let {data}=await instance.delete(URL,{params})
   // hideLoading();
    return data;
}



  
//   // 请求拦截器
//   instance.interceptors.request.use(
//     config => {
//       // 显示加载中提示
//       showLoading();
//       // 可以在这里添加 token 等请求头信息
//       return config;
//     },
//     error => {
//       // 请求错误时隐藏加载提示
//       hideLoading();
//       console.error('请求错误:', error);
//       return Promise.reject(error);
//     }
//   );
  
//   // 响应拦截器
//   instance.interceptors.response.use(
//     response => {
//       // 响应成功时隐藏加载提示
//       hideLoading();
//       return response;
//     },
//     error => {
//       // 响应错误时隐藏加载提示
//       hideLoading();
//       console.error('响应错误:', error);
//       return Promise.reject(error);
//     }
//   );
  


// 请求拦截器
instance.interceptors.request.use(
    config => {
      // 可以通过配置控制是否显示加载
      if (config.showSpin !== false) {
        showSpin();
      }
      return config;
    },
    error => {
      hideSpin();
      return Promise.reject(error);
    }
  );
  
  // 响应拦截器
  instance.interceptors.response.use(
    response => {
        hideSpin();
      return response;
    },
    error => {
      // 即使出错也需要隐藏加载
      hideSpin();
      return Promise.reject(error);
    }
  );